var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from 'pixi.js';
import { BaseDeformer } from "./BaseDeformer";
import { DEFORMER_MANIP_ENUM } from "../enums";
var VertexTransformDeformer = /** @class */ (function (_super) {
    __extends(VertexTransformDeformer, _super);
    function VertexTransformDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.VERTEX];
        _this.offset = new PIXI.Point();
        return _this;
    }
    VertexTransformDeformer.prototype._uniforms = function () {
        var _a;
        return _a = {},
            _a["offset".concat(this.index)] = this.offset,
            _a;
    };
    VertexTransformDeformer.prototype._vertexHeader = function () {
        return "\n        uniform vec2 offset".concat(this.index, ";\n        ");
    };
    VertexTransformDeformer.prototype._vertBody = function () {
        return "\n            vec3 getVertexPosition".concat(this.index, "(vec3 inputPosition) {\n                // add offset to inputPosition\n                return vec3(offset").concat(this.index, ".xy, 0) + inputPosition;\n            }\n        ");
    };
    return VertexTransformDeformer;
}(BaseDeformer));
export { VertexTransformDeformer };
